import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useTheme, alpha } from '@mui/material/styles';
import useSessionContext from '../../../data/queryHooks/useSessionContext';

const LinkBehavior = forwardRef((props, ref) => (
	<RouterLink ref={ref} to='/switchLocation' {...props} />
));

LinkBehavior.displayName = 'LinkBehavior';

const UserInfoHeaderMobile = props => {
	const { palette } = useTheme();
	const transparentBackground = alpha(palette.primary.main, 0.08);

	const { userInfo } = useSessionContext();
	const {
		lastName = '',
		firstName = '',
		address1 = '',
		city = '',
		state = '',
		zipCode = '',
	} = userInfo;

	return (
		<Box
			sx={{
				padding: '16px',
				display: 'flex',
				height: '178px',
				backgroundColor: transparentBackground,
				justifyContent: 'flex-start',
				alignItems: 'flex-start',
			}}
		>
			<Stack
				color={palette.text.primary}
				direction='column'
				justifyContent='flex-end'
				spacing={2}
			>
				<Typography variant='subtitle2'>
					{`${firstName} ${lastName}`}
				</Typography>
				<Typography variant='subtitle2'>
					{`${address1} - ${city}, ${state} ${zipCode}`}
				</Typography>
				<Typography variant='subtitle2'>Fitness</Typography>

				{props?.hasDefaultLocation && (
					<Link
						component={LinkBehavior}
						variant='subtitle2'
						sx={{ zIndex: 9 }}
					>
						Switch Location
					</Link>
				)}
			</Stack>
		</Box>
	);
};
export default UserInfoHeaderMobile;

UserInfoHeaderMobile.propTypes = {
	hasDefaultLocation: PropTypes.bool.isRequired,
};
